export function wordCountToColor(wordCount, recommendedWordCount){
  const comparisonFactor = wordCount / recommendedWordCount;
  if(comparisonFactor > 1.6){
    return 'color-1';
  } else if(comparisonFactor > 1.3){
    return 'color-2';
  } else if( comparisonFactor > .9){
    return 'color-3';
  } else if( comparisonFactor > .7){
    return 'color-4';
  } else if( comparisonFactor > .6){
    return 'color-5';
  } else if( comparisonFactor > .4){
    return 'color-6';
  } else if( comparisonFactor > .2 ){
    return 'color-7';
  } else if( comparisonFactor > .1 ){
    return 'color-8';
  } else if(comparisonFactor === 0){
  	return 'color-na'
  } else {
    return 'color-9';
  }
}

export function wordCountToWidth(wordCount, maxWordCount){
  var percentage = Math.floor( (wordCount / maxWordCount)*100 );
  if(percentage < 10){
  	percentage = 10;
  }
  return percentage + '%';
}

export function numberWithCommas(num) {
  if(Number.isFinite(num)){
  	if(num === 0){
  		return 'NA';
  	} else{
  		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  	}
  	
  } else{
  	return num;
  }
}